// raw search params created on app's init time
export const urlSearchParams = new URLSearchParams(window.location.search);